import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
// import * as R from 'ramda';
import * as toTitleCase from 'title-case';
import {
  EditOutlined,
  FileSearchOutlined,
  // UserOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';

// Components
// import ManagePendingRequest from '../../../components/Modals/ManagePendingRequest';
// import { getOrgAdmins } from '../../../graphql/organizationDetails';
// import { UpdateOrganization } from '../../../graphql/organization';
import EditOrganization from '../../Modals/EditOrganization';
// Local Deps

import './PendingRequest.scss';
import msgs from '../../../config/messages';
// import { updateUser, createUser } from '../../../graphql/updateUsers';
// import { createUser } from '../../../graphql/users';
// import { updateUserMetaData } from './graphql';

export default class PendingRequest extends React.PureComponent {
  static propTypes = {
    auth: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired,
      expiration: PropTypes.number.isRequired,
      organizationId: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
    }).isRequired,
    requests: PropTypes.instanceOf(Array).isRequired,
    requestType: PropTypes.string.isRequired,
    // auth: PropTypes.object.isRequired,
    refreshOrganizations: PropTypes.func.isRequired,
  };

  static defaultProps = {};

  static initialState = {
    // modalDisplayed: false,
    // rowIndex: 0,
    // requestedAdmins: [],
    // selectedRowKeys: [],
    // action: null,
    selectedOrganizationId: undefined,
    // orgType: null,
    // organizationUsers: [],
  };

  static formatRequest(requests) {
    return requests.map(request => ({
      ...request,
      entityName: request.name,
      iconStatus: toTitleCase(request.iconStatus),
    }));
  }

  state = PendingRequest.initialState;

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedOrganizationId: undefined,
    });
  }

  openEditModal = (itemId) => {
    this.setState({
      showEditModal: true,
      selectedOrganizationId: itemId,
    });
  }

  // _getIndex = async row => {
  //   const id = this.props.requests[row.index].id;

  //   this.setState({
  //     // rowIndex: row.index,
  //     selectedOrganizationId: id,
  //   });
  //   try {
  //     const response = await getOrgAdmins(id);
  //     this.setState({
  //       requestedAdmins: response.organization.admins,
  //       organizationUsers: response.organization.users,
  //       orgType: response.organization.organizationType,
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  //   this._ToggleModal(true);


  // };

  // _ToggleModal = modalDisplayed => this.setState({ modalDisplayed });

  // _changeOrg = e => {
  //   this.setState({
  //     orgType: e.target.value.toLowerCase(),
  //   });
  // };

  // selectRow = record => {
  //   const selectedRowKeys = [...this.state.selectedRowKeys];
  //   if (selectedRowKeys.indexOf(record.key) >= 0) {
  //     selectedRowKeys.splice(selectedRowKeys.indexOf(record.key), 1);
  //   } else {
  //     selectedRowKeys.push(record.key);
  //   }
  //   this.setState({ selectedRowKeys });
  // };

  // _onSelectedRowKeysChange = selectedRowKeys => {
  //   this.setState({ selectedRowKeys });
  // };

  // _onSelectedAction = selectedAction => {
  //   this.setState({
  //     action: selectedAction,
  //   });
  // };

  // _denyAdmin = deniedAdmins => {
  //   deniedAdmins.map(deniedAdmin => {
  //     deniedAdmin.role = 'user';
  //     delete deniedAdmin.key;
  //     delete deniedAdmin.index;
  //     updateUser(deniedAdmin);


  //     return deniedAdmin;
  //   });
  //   return '';
  // };

  // _handleOrg = async () => {
  //   const org = {
  //     organizationType: this.state.orgType,
  //     iconStatus: this.state.action,
  //     id: this.state.selectedOrganizationId,
  //   };
  //   await UpdateOrganization(org);


  // };

  // _handleOrgAdmin = async approvedAdmins => {
  //   approvedAdmins.map(admin => {
  //     admin.role = 'admin';
  //     admin.iconStatus = 'approved'
  //     const response = createUser(admin);
  //     console.log(response);

  //     return admin;
  //   });
  //   return '';
  // };

  // _blockOrganizationUsers = async () => {
  //   this.state.organizationUsers.map(user => {
  //     if (user.role.includes('admin')) {
  //       user.role = 'admin';
  //     } else {
  //       user.role = 'user';
  //     }
  //     createUser(user);



  //     return user;
  //   });
  //   return '';
  // };

  // _getApprovedAdmins = requestedAdmins => {
  //   const approvedAdmins = R.innerJoin(
  //     (record, key) => record.id === key,
  //     requestedAdmins,
  //     this.state.selectedRowKeys,
  //   );
  //   return approvedAdmins;
  // };

  // _getNonApprovedAdmins = (requestedAdmins, approvedAdmins) => {
  //   approvedAdmins.map(user => {
  //     // remove all approved admins from requested admin list
  //     requestedAdmins.splice(user.index, 1);
  //     return user;
  //   });
  //   return requestedAdmins;
  // };

  // _onSave = async () => {
  //   if (!this.state.action) {
  //     message.warning('you must select an Action');
  //     return;
  //   }
  //   const requestedAdmins = this.state.requestedAdmins;

  //   const approvedAdmins = this._getApprovedAdmins(requestedAdmins);
  //   const nonApprovedAdmins = this._getNonApprovedAdmins(
  //     requestedAdmins,
  //     approvedAdmins,
  //   );
  //   if (approvedAdmins.length === 0 && this.state.action === 'approved') {
  //     message.warning('you must select an org admin');
  //     return;
  //   }



  //   if (
  //     this.props.requestType === 'approved' &&
  //     this.state.action === 'denied'
  //   ) {
  //     await this._handleOrg();
  //     this._blockOrganizationUsers();
  //   } else {
  //     this._denyAdmin(nonApprovedAdmins);
  //     await this._handleOrg();
  //     this._handleOrgAdmin(approvedAdmins);
  //   }
  // };

  // _onClose = () => {
  //   this.setState({
  //     selectedRowKeys: [],
  //   });
  //   this._ToggleModal(false);
  // };


  // _onAdminClick = async orgInfo => {
  //   const res = await updateUserMetaData(this.props.auth.id, orgInfo.id);
  //   if (res) {
  //     // gotta remove the cookie or it will load the old cookie info on the redirect
  //     document.cookie = 'idToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';

  //     window.location.replace(
  //       '/login?redirect=%2Fmemberadmin%2Fhome%2FviewUsers',
  //     );
  //   }
  // };

  render() {
    const { requests, requestType, refreshOrganizations } = this.props;
    // const { modalDisplayed } = this.state;
    const pageSize = 20;

    // Note that the grid configFile for this directory does not configure the request table, but the details table inside of the modal.
    const columns = [
      {
        Header: 'Organization Name',
        accessor: 'name',
      },
      {
        Header: 'CAGE',
        accessor: 'cageCode',
        width: 80,
      },
      {
        Header: 'Industry Type',
        accessor: 'industryType',
        width: 140,
        Cell: ({ value }) => {
          if (Array.isArray(value)) {
            return value.join(' | ');
          }
          return value;
        },
      },
      {
        Header: 'Industry Affiliation',
        accessor: 'industryAssociations',
        width: 140,
        Cell: ({ value }) => {
          if (Array.isArray(value)) {
            return value.join(' | ');
          }
          return value;
        },
      },
      {
        Header: 'Org Admin',
        accessor: 'admins[0].name',
        width: 140,
      },
      {
        Header: 'Email Address',
        accessor: 'admins[0].email',
      },
      {
        Header: 'Phone Number',
        accessor: 'admins[0].phoneNumber',
        width: 140,
      },
      {
        Header: 'Subscription Level',
        accessor: 'admins[0].subscriptionLevel',
        width: 140,
      },
      {
        Header: 'Icon Status',
        accessor: 'iconStatus',
        width: 140,
      },
      {
        Header: 'Date Added',
        accessor: 'approvalDate',
        width: 140,
      },
      {
        Header: 'Action',
        id: 'row',
        accessor: 'action',
        minWidth: 130,
        Cell: row => (
          <React.Fragment>
            {/* <Button
              type="default"
              onClick={() => {
                this._getIndex(row);
              }}
              style={{ fontSize: '11px', margin: '7px' }}
            >
              <Icon type="search" />
              Details
            </Button> */}
            <Button
              type="default"
              // href={`/superadmin/edit/organization/${row.original.id}`}
              onClick={() => {
                this.openEditModal(row.original.id);
              }}
              style={{ fontSize: '11px', margin: '7px' }}
            >
              {requestType === 'pending' ? (
                <React.Fragment>
                  <FileSearchOutlined />
                  Review
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <EditOutlined />
                  Edit
                </React.Fragment>
              )}
            </Button>
            {/* The below button adds the administration (proxy) option */}
            {/* {requestType === 'approved' && (
              <Button
                type="default"
                onClick={() => this._onAdminClick(row.original)}
                style={{ fontSize: '11px', margin: '7px' }}
              >
                <UserOutlined />
                Administration
              </Button>
            )} */}
          </React.Fragment>
        ),
      },
    ];

    return (
      <div className="nf-view-users-grid">
        <ReactTable
          data={PendingRequest.formatRequest(requests)}
          columns={columns}
          showPageSizeOptions={false}
          showPagination={requests.length > pageSize}
          noDataText={msgs.ViewPendingRequest.noDataText}
          defaultPageSize={pageSize}
          responsive
        />
        {this.state.showEditModal && this.state.selectedOrganizationId &&
          <EditOrganization
            selectedOrganizationId={this.state.selectedOrganizationId}
            showEditModal={this.state.showEditModal}
            auth={this.props.auth}
            closeEditModal={this.closeEditModal}
            refreshOrganizations={refreshOrganizations}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/PendingRequest/PendingRequest.jsx